import sitemateLogoAsset from "@/assets/sitemate-logo.png.asset.json";
const sitemateLogo = sitemateLogoAsset.url;

interface SitemateFooterProps {
  fixed?: boolean;
  generatorSlug: string;
  placement: "footer" | "about" | "download";
}

const SitemateFooter = ({ fixed = true, generatorSlug, placement }: SitemateFooterProps) => {
  const positionClass = fixed ? "fixed bottom-4 left-0 right-0" : "flex";
  const sitemateUrl = `https://sitemate.com?utm_source=${generatorSlug}&utm_medium=generator&utm_campaign=generator_branding&utm_content=${placement}`;
  
  return (
    <div className={`${positionClass} flex items-center justify-center gap-2`}>
      <span className="text-sm text-foreground/50">Made with 💙 by</span>
      <a href={sitemateUrl} target="_blank" rel="noopener noreferrer">
        <img src={sitemateLogo} alt="Sitemate" className="h-[0.925rem] inline-block" />
      </a>
    </div>
  );
};

export default SitemateFooter;
